import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { TicketViewService } from '../../ticket-view.service';
import { Enums } from '../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss'],
  standalone: false,
})
export class AddCommentComponent implements OnInit {
  public Enums = Enums;
  public comment: string;
  public ticketCommentLoading: boolean;
  public ticketCommentError: string | null;

  @Input() ticketId;
  @Input() type;
  @Output() addEsasComment = new EventEmitter<any>();

  @ViewChild('p2') public popover: NgbPopover;

  constructor(private ticketViewService: TicketViewService) {}

  ngOnInit() {}

  public onAddComment() {
    this.ticketCommentLoading = true;
    this.ticketViewService.ticketAddComment(this.ticketId, { comment: this.comment }).subscribe(
      (response) => {
        this.ticketCommentLoading = false;
        this.ticketCommentError = null;
        this.addEsasComment.emit(response['data']);
        this.popover.close();
      },
      (error) => {
        console.log(error);
        this.ticketCommentLoading = false;
        this.ticketCommentError = null;
        this.ticketCommentError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
      }
    );
  }

  public toggleWithCommentContext(popover: NgbPopover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
}
